import layoutClearDeskWineConfiscation from '@/views/confiscation/clear-desk-wine-confiscation/components/LayoutClearDeskWineConfiscation.vue'
export default {
  name: 'group-spm-confiscation',
  meta: { title: '充公', icon: 'icon-order' },

  children: [
    {
      name: 'spm-confiscation',
      meta: { title: '充公', icon: 'el-icon-cold-drink' },

      routers: [
        {
          path: '/confiscation/clear-desk-wine-confiscation',
          name: 'confiscation:clear-desk-wine-confiscation',
          component: layoutClearDeskWineConfiscation,
          meta: { title: '清台酒水充公' },
          children: [
            {
              path: 'index',
              name: 'index',
              component: () =>
                import('@/views/confiscation/clear-desk-wine-confiscation/index.vue'),
              meta: {
                title: '充公录入',
                vPermission: ['pc-bar-confiscation:clear-desk-wine-confiscation:index']
              }
            },
            {
              path: 'today-confiscation',
              name: 'today-confiscation',
              component: () =>
                import('@/views/confiscation/clear-desk-wine-confiscation/today-confiscation.vue'),
              meta: { title: '今日充公' }
            }
          ]
        }
      ]
    }
  ]
}
